export const userKey = 'user'
export const accessTokenKey = 'accessToken'
export const selectedPanelKey = 'selectedPanel'
